'use strict'

import DatePicker from 'react-datepicker'
import React from 'react'
import Icon from '../Icon'

import 'react-datepicker/dist/react-datepicker.css'
import './DatePicker.less'

export default class DatePickerComponent extends React.Component {
  render () {
    let _calendar
    // When this is fixed, we can get rid of this ref:
    // https://github.com/Hacker0x01/react-datepicker/issues/283
    const datePickerClassName = this.props.errorText
      ? `${this.props.className} nmc-datepicker-input-error`
      : this.props.className
    return (
      <div className='nmc-datepicker-container'>
        <div className='nmc-datepicker-date-and-label-container'>
          <label
            className='nmc-datepicker-image'
            onClick={() => _calendar.setOpen(true)}
          ><Icon name='calendar' size='large' /></label>
          <DatePicker {...this.props}
            className={datePickerClassName}
            ref={(c) => {
              _calendar = c
              return _calendar
            }}
          />
        </div>
        <div className='nmc-datepicker-error'>{this.props.errorText}</div>
      </div>
    )
  }
}

DatePickerComponent.defaultProps = {
  className: 'nmc-datepicker-input',
  locale: 'en',
  placeholderText: 'mm / dd / yy',
  errorText: ''
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/DatePicker/index.js